import { styled } from 'styled-components';

import CommonButtonDelete from '../../Common/ButtonDelete';

export const ButtonDelete = styled(CommonButtonDelete)`
  padding: var(--spacing-small) 0;
`;
